<template>
  <div>
    <div class="post-list-container">
      <div v-if="posts.length > 0" class="post-list">
        <v-card class="mb-4 post-item">
          <div class="px-6">
            <h1>Księga gości</h1>
            <p class="py-4">
              Witajcie! Z okazji kawalerskiego naszego wspaniałego kolegi
              Jakuba, zapraszamy Was do zostawienia kilku słów, życzeń,
              wspomnień lub śmiesznych anegdotek. Podzielcie się swoją radością
              i wspólnymi chwilami, aby stworzyć niezapomnianą pamiątkę dla
              przyszłego Pana Młodego!
            </p>
            <p class="text-center text-h4">⬇️</p>
          </div>
        </v-card>
        <div v-for="post in posts" :key="post.id" class="post-item">
          <PostDetail :id="post.id" />
        </div>
      </div>
      <div v-else class="text-center">
        <p>Brak wpisów w księdze.</p>
        <v-btn color="primary" to="/add" text>Dodaj wpis</v-btn>
      </div>
    </div>

    <v-fab
      color="red"
      extended
      size="x-large"
      text="Dodaj wpis"
      style="
        position: fixed;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%);
      "
      to="/add"
    ></v-fab>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { db } from "@/firebaseConfig";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import PostDetail from "./PostDetail.vue"; // Importuj komponent PostDetail

export default {
  components: {
    PostDetail, // Zarejestruj komponent
  },
  setup() {
    const posts = ref([]);
    let unsubscribe = null;

    onMounted(() => {
      const postsCollection = collection(db, "posts");
      const q = query(postsCollection, orderBy("createdAt", "desc"));

      // Nasłuchiwanie zmian w czasie rzeczywistym
      unsubscribe = onSnapshot(q, (snapshot) => {
        posts.value = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      });
    });

    onUnmounted(() => {
      // Odłącz nasłuchiwanie, gdy komponent zostanie zniszczony
      if (unsubscribe) {
        unsubscribe();
      }
    });

    return {
      posts,
    };
  },
};
</script>

<style scoped>
/* Możesz dodać własne style, jeśli potrzebujesz */
.post-list-container {
  height: calc(100svh - 64px);
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  max-width: 400px;
  margin: 0px auto;
}

.post-list {
  display: flex;
  flex-direction: column;
}

.post-item {
  scroll-snap-align: start;
  height: calc(100svh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
